export const mediaQueryLarge = window.matchMedia('(min-width: 1920px)');
export const isBigScreen = window.matchMedia('(min-width: 2560px)');
export const isLaptopScreen = window.matchMedia('(min-width: 1440px)');


export const getSpan = (
  isMobile?: boolean,
  isTablet?: boolean,
  productLayout?: string | undefined,
  isBanner?: number | undefined
) => {
  if (!isMobile && productLayout === 'vertical' && isLaptopScreen.matches) {
    if (isBanner !== 0) {
      return 6;
    }
    return 4;
  }

  if (isMobile && productLayout === 'vertical') {
    return 12;
  }
  if (isTablet) {
    if (productLayout === 'vertical') {
      return 8;
    }
    return 12;
  }

  return productLayout === 'vertical' ? 4 : 7;
};

export const colSpan = (
  mobileSpan?: number,
  isMobile?: boolean,
) => {
  if (isMobile && mobileSpan === 0) {
    return 0;
  }
  return 24;
};
